import { AssetTypeServiceBase } from './asset-type.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@scisys-uim/uim-common';
import { AssetType } from 'assets-model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AssetTypeService extends AssetTypeServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  public findByName(name: string): Observable<AssetType> {
    return this.deserialise(this.http.get<AssetType>(this.serviceBaseUrl + '/findByName/' + name));
  }

}



